import module from 'module';
import $ from 'jquery';

import templateUrl from './layaway-agreement-form-view.template.html';
import './layaway-agreement-form-view.style.less';

class LayawayAgreementFormViewComponent {
  constructor($route, $location, http, nav, printService, $timeout) {
    this.$route = $route;
    this.$location = $location;
    this.http = http;
    this.nav = nav;
    this.printService = printService;
    this.$timeout = $timeout;
  }

  $onInit() {
    const layawayId = this.$route.current.params['layawayId'];
    this.$timeout(() => {
      this.http.post(`/print/LAYAWAY_AGREEMENT_FORM/json`, {layawayId}).success(doc => {
        this.doc = doc;

        return this.printService.printToContainer(doc, {
          autoPrint: false,
          backgroundEnabled: true,
          container: $('.iframe-preview')
        });
      });
    });
  }

  redirectBack() {
    this.nav.back()
  }

  print() {
    this.printService.printToContainer(this.doc, {
      autoPrint: true,
      backgroundEnabled: false,
      container: $('.iframe-invisible')
    });
  }
}

module.component('layawayAgreementFormView', {
  templateUrl: templateUrl,
  controller: LayawayAgreementFormViewComponent
});